/**
 * v4.12.0 — Selection checkbox for the Fleet table.
 *
 * Subtle by default: 30% opacity, only fully visible on row hover OR
 * when the row is already selected OR when any row in the fleet is
 * selected (so the operator can re-find selections at a glance). The
 * goal is to preserve the premium operational feel of the table — no
 * spreadsheet vibes — while still giving fast multi-select reach.
 */
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function SelectionCheckbox({
    checked,
    onToggle,
    anySelected,
    testId,
    insightId,
}) {
    const { t } = useTranslation();

    const visible = checked || anySelected;
    return (
        <button
            type="button"
            role="checkbox"
            aria-checked={!!checked}
            aria-label={t("card_fleet.bulk.select_row")}
            data-testid={testId}
            data-insight-id={insightId}
            data-insight-label={insightId ? "Row selection" : undefined}
            onClick={(e) => {
                e.stopPropagation();
                onToggle(!checked);
            }}
            className={`
                w-5 h-5 rounded-md border flex items-center justify-center transition-all
                ${visible ? "opacity-100" : "opacity-30 group-hover:opacity-100"}
                ${checked
                    ? "bg-sky-400/90 border-sky-300/80 text-slate-900"
                    : "bg-transparent border-slate-500/60 hover:border-sky-300/70"}
            `}
            style={{ flexShrink: 0 }}
        >
            {checked ? <Check size={12} strokeWidth={3} /> : null}
        </button>
    );
}
